import Swiper from 'swiper/bundle';
export function initializeCarouselReceip() {
  var mainSwiper = new Swiper(".swiper-receip", {
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next-carousel",
      prevEl: ".swiper-button-prev-carousel"
    },
    on: {
      slideChange: function slideChange() {
        var activeIndex = this.realIndex;
        var activeSlide = document.querySelectorAll('.swiper-slide')[activeIndex];
        if (activeSlide) {
          var block = activeSlide.querySelector('.product-block');
          if (block) {
            var backgroundColor = block.querySelector('.large-image-container').style.backgroundColor || block.getAttribute('data-background-color');
            var recipeSectionBackground = document.querySelector('.recipeSectioBackground');
            if (backgroundColor && recipeSectionBackground) {
              recipeSectionBackground.style.backgroundColor = backgroundColor;
            }
          }
        }
      }
    }
  });
}